export function shouldShowContent({ devices, isVideoInitialized }) {
  return devices?.length && isVideoInitialized
}
